
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const About = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-dark-300 pt-24">
        {/* Hero Section */}
        <section className="py-16 bg-black">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                {t('about.heroTitle')} <span className="text-gradient">Foto</span>
              </h1>
              <p className="text-xl text-gray-300 mb-10">
                {t('about.heroSubtitle')}
              </p>
              <div className="flex justify-center">
                <img src="/lovable-uploads/5b334a58-6e41-4c11-8297-2f8f799c17ee.png" alt="Mike Foto" className="w-64 h-64 rounded-full object-cover border-4 border-brand" />
              </div>
            </div>
          </div>
        </section>

        {/* Introduction Section */}
        <section className="py-16 bg-dark-300">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <p className="text-2xl text-white text-center font-medium leading-relaxed mb-12">
                {t('about.introText')}
              </p>
            </div>
          </div>
        </section>

        {/* Background Section */}
        <section className="py-16 bg-black">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white text-center">
                {t('about.backgroundTitle')}
              </h2>
              
              <div className="space-y-6 text-lg text-gray-300">
                <p>{t('about.backgroundText1')}</p>
                <p>{t('about.backgroundText2')}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Current Work Section */}
        <section className="py-16 bg-dark-300">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white text-center">
                {t('about.currentTitle')}
              </h2>
              
              <div className="space-y-6 text-lg text-gray-300">
                <p>{t('about.currentIntro')}</p>
                
                <div className="bg-dark-200 p-6 rounded-lg border border-gray-800 mb-4">
                  <h3 className="text-xl text-white font-semibold mb-2">TapG.gr</h3>
                  <p>{t('about.tapgDescription')}</p>
                </div>
                
                <div className="bg-dark-200 p-6 rounded-lg border border-gray-800 mb-6">
                  <h3 className="text-xl text-white font-semibold mb-2">RentMySite.gr</h3>
                  <p>{t('about.rentmysiteDescription')}</p>
                </div>
                
                <p>{t('about.currentText')}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Working Style Section */}
        <section className="py-16 bg-black">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white text-center">
                {t('about.workingTitle')}
              </h2>
              
              <div className="space-y-6 text-lg text-gray-300">
                <p>{t('about.workingText1')}</p>
                <p className="text-white font-medium text-center text-xl mt-8">
                  {t('about.workingText2')}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-dark-300">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h3 className="text-2xl font-bold text-white mb-8">
                {t('about.ctaTitle')}
              </h3>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button size="lg" className="bg-brand hover:bg-brand-hover text-white font-medium" asChild>
                  <Link to="/services">{t('about.ctaServices')}</Link>
                </Button>
                <Button size="lg" className="bg-dark-200 hover:bg-dark-100 text-white border border-gray-700 font-medium" asChild>
                  <Link to="/work">{t('about.ctaWork')}</Link>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default About;
